/**
 * Hook for managing paginated data
 */
export interface PaginationState<T> {
  items: T[];
  page: number;
  hasMore: boolean;
  loading: boolean;
}

export interface PaginatedResponse<T> {
  results: T[];
  next: string | null;
  previous: string | null;
  count: number;
}

/**
 * Default page size for pagination
 */
export const DEFAULT_PAGE_SIZE = 20;
